// extracted by mini-css-extract-plugin
module.exports = {"item":"i2","dark":"i3","light":"i4","toggle":"i5"};